var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDirExpand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "12px",
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-36.000000, -152.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.000000, 152.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4429599,11.1161665 C12.4429599,11.599343 12.0514471,11.9893022 11.5698242,11.9893022 L0.660289418,11.9893022 L2.1875,4.93275036 C2.1875,4.45112749 2.57590554,4.0596147 3.05908203,4.0596147 L13.0985884,4.0596147 C13.5802113,4.0596147 13.9701705,4.45112749 13.9701705,4.93275036 L12.4429599,11.1161665 L12.4429599,11.1161665 Z",
    fill: "#8788A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.4050071,3.40398615 L12.2238991,3.40398615 L12.2238991,2.54638672 C12.2238991,2.06476385 11.8323864,1.67325107 11.3507635,1.67325107 L6.11505682,1.67325107 L6.11505682,0.882457386 C6.11505682,0.400834517 5.72354403,0.00932173295 5.24192116,0.00932173295 L0.879350142,0.00932173295 C0.397727273,0.00932173295 0.00621448864,0.400834517 0.00621448864,0.882457386 L0.00621448864,11.1146129 L1.53187145,4.27556818 C1.53187145,3.79549893 1.92338423,3.40398615 2.4050071,3.40398615 Z",
    fill: "#60617F"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirExpand);
export default __webpack_public_path__ + "static/media/dirExpand.185398257ef06da576c2a9a373fb5e53.svg";
export { ForwardRef as ReactComponent };